import React, { useState, useRef } from "react";

const Register = () => {
  const form = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  const validateForm = (formData) => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (!formData.user_name.trim()) {
      newErrors.user_name = "Name is required";
    }

    if (!formData.user_email.trim()) {
      newErrors.user_email = "Email is required";
    } else if (!emailRegex.test(formData.user_email)) {
      newErrors.user_email = "Invalid email format";
    }

    if (!formData.user_phone.trim()) {
      newErrors.user_phone = "Phone is required";
    } else if (!phoneRegex.test(formData.user_phone)) {
      newErrors.user_phone = "Phone must be 10 digits";
    }

    if (!formData.course_name.trim()) {
      newErrors.course_name = "Course is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSuccessMessage("");
    
    const formData = {
      user_name: e.target.user_name.value,
      user_email: e.target.user_email.value,
      user_phone: e.target.user_phone.value,
      course_name: e.target.course_name.value
    };

    if (!validateForm(formData)) {
      setIsSubmitting(false);
      return;
    }

    try {
      // Using fetch instead of axios
      const response = await fetch("https://api.dikshasea.in/api/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      
      if (result.success) {
        setSuccessMessage("Registration submitted successfully! We'll contact you shortly.");
        e.target.reset();
      } else {
        alert("Registration failed: " + (result.message || "Please try again later"));
      }
    } catch (error) {
      console.error("Registration error:", error);
      alert("An error occurred. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="apply-area admission-area py-5">
      <div className="d-table">
        <div className="d-table-cell">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-12">
                <div className="text">
                  <p>
                    Register today and enjoy an <span>exclusive</span> discount
                    on any course!
                  </p>
                </div>
              </div>

              <div className="col-lg-6 col-md-12">
                <div className="apply-form">
                  <h3>Apply Now</h3>
                  {successMessage && (
                    <div className="alert alert-success">{successMessage}</div>
                  )}
                  <form ref={form} onSubmit={sendEmail}>
                    <div className="form-group">
                      <input
                        type="text"
                        className={`form-control ${errors.user_name ? "is-invalid" : ""}`}
                        name="user_name"
                        placeholder="Your Name"
                      />
                      {errors.user_name && (
                        <div className="invalid-feedback">{errors.user_name}</div>
                      )}
                    </div>

                    <div className="form-group">
                      <input
                        type="email"
                        className={`form-control ${errors.user_email ? "is-invalid" : ""}`}
                        name="user_email"
                        placeholder="Your Email"
                      />
                      {errors.user_email && (
                        <div className="invalid-feedback">{errors.user_email}</div>
                      )}
                    </div>

                    <div className="form-group">
                      <input
                        type="tel"
                        className={`form-control ${errors.user_phone ? "is-invalid" : ""}`}
                        name="user_phone"
                        placeholder="Your Phone"
                        maxLength="10"
                      />
                      {errors.user_phone && (
                        <div className="invalid-feedback">{errors.user_phone}</div>
                      )}
                    </div>

                    <div className="form-group">
                      <input
                        type="text"
                        className={`form-control ${errors.course_name ? "is-invalid" : ""}`}
                        name="course_name"
                        placeholder="Course Looking For"
                      />
                      {errors.course_name && (
                        <div className="invalid-feedback">{errors.course_name}</div>
                      )}
                    </div>

                    <button 
                      type="submit" 
                      className="btn btn-primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Apply Now"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Register;